import React, { Component } from "react";
import { Button, Row, Col, MDBBtn } from "mdbreact";
import axios from "axios";
import domain from "./domain";
import { Link } from "react-router-dom";

function dateFormatter(cell) {
  let s = new Date(cell);

  return `${("0" + s.getDate()).slice(-2)}/${("0" + (s.getMonth() + 1)).slice(
    -2
  )}/${s.getFullYear()}`;
}
/**
 *
 */
export default class AllCourses extends Component {
  constructor() {
    super();
    this.state = {
      courses: [],
      sessions: [],
      trainees: [],
    };
  }

  componentDidMount() {
    this.getCourses();
    this.getSessions();
    this.getTrainees();
  }
  statusFormatter(cell, row, enumObject, index) {
    return <div>{index + 1}</div>;
  }

  getSessions() {
    axios
      .get(`${domain.DBServer}/fetch-sessions`)
      .then((response) => {
        if (response) {
          this.setState({ sessions: response.data }, () => {});
        }
      })
      .catch((err) => console.log(err));
  }

  getCourses() {
    axios
      .get(`${domain.DBServer}/fetch-course-participants`)
      .then((response) => {
        if (response) {
          this.setState({ courses: response.data }, () => {});
        }
      })
      .catch((err) => console.log(err));
  }

  getTrainees() {
    axios
      .get(`${domain.DBServer}/fetch-participants`)
      .then((response) => {
        if (response) {
          this.setState({ trainees: response.data }, () => {});
        }
      })
      .catch((err) => console.log(err));
  }

  render() {
    const courses = this.state.courses;
    let course_years = [],
      course_participants = [];
    let coursetable;

    if (courses) {
      //  console.log(courses)
      coursetable = courses.map((course, key) => {
        let category;
        switch (parseInt(course.cat_id, 10)) {
          case 1:
            category = "One Week";
            break;
          case 2:
            category = "Two Week";
            break;
          case 3:
            category = "Customized";
            break;
          default:
            category = null;
        }
        if(window.innerWidth>1000)
        {
        return (
         
         <tr key={key}>
          
            <th scope="row">{key + 1}</th>
          
            <td>{course.year}</td>
            <td>{course.title}</td>
            <td>{category}</td>
            <td>{dateFormatter(course.start_date)}</td>
            <td>{dateFormatter(course.end_date)}</td>
            <td>{course.status}</td>
            {course.count === null ? (
              <td style={{ textAlign: "right" }}>0</td>
            ) : (
              <td style={{ textAlign: "right" }}>{course.count}</td>
            )}

            <td style={{ textAlign: "center" }}>
              {" "}
              <Link to={`/trainingnew/view-schedules/${course.course_id}`}>
                {" "}
                <MDBBtn size="sm" color="primary">
                  {" "}
                  Schedule{" "}
                </MDBBtn>
              </Link>
              <Link to={`/trainingnew/view-trainees/${course.course_id}`}>
                {" "}
                <MDBBtn size="sm" className="capitalize"> Trainee </MDBBtn>
              </Link>
              
            </td>
          </tr>

        );
      }
      else 
      {
        return (
         
          <tr key={key}>
           
           
             <td>{course.title}</td>
            
             <td>{dateFormatter(course.start_date)}</td>
            
           
             {course.count === null ? (
               <td style={{ textAlign: "right" }}>0</td>
             ) : (
               <td style={{ textAlign: "right" }}>{course.count}</td>
             )}
 
             {/* <td style={{ textAlign: "center" }}>
               {" "}
               <Link to={`/trainingnew/view-schedules/${course.course_id}`}>
                 {" "}
                 <MDBBtn size="sm" color="primary">
                   {" "}
                   Schedule{" "}
                 </MDBBtn>
               </Link>
               <Link to={`/trainingnew/view-trainees/${course.course_id}`}>
                 {" "}
                 <MDBBtn size="sm" className="capitalize"> Trainee </MDBBtn>
               </Link>
               
             </td> */}
           </tr>)
 
      }
      });
      if (courses) {
        courses.map((course) => {
          course_years.push(course.year);
          course_participants.push(course.count);
          return true;
        });
      }
      console.log(course_participants, course_years);
    }
    return (
     
        <Col md="12">
          <table
            className="table table-bordered"
            cellSpacing="0"
            width="100%"
            
          >
            <thead style={{ textAlign: "center", backgroundColor: "#33b5e5" }}>
            {window.innerWidth>1000? 
              <tr>
              
               <th scope="col">S. No</th>
                
                <th scope="col">Year</th>
                <th scope="col">Title of the Course</th>
                <th scope="col">Category</th>
                <th scope="col">Start Date</th>
                <th scope="col">End Date</th>
                <th scope="col">Status</th>
                <th scope="col">Number of Participants</th>
                <th scope="col">View</th>

              </tr>
              : <tr> <th scope="col">Title of the Course</th>
              <th scope="col">Start Date</th>
              <th scope="col">Number of Participants</th>
            </tr>} 

            </thead>
            <tbody>{coursetable}</tbody>
          </table>
        </Col>
      
    );
  }
}
